(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.weaver_news = {

    scrollNewsFilters: function() {
      const newsBlock = document.getElementById('ptb-news');
      
      if (newsBlock == null || window.location.search == '') {
        return;
      }

      newsBlock.scrollIntoView();
    },

    attach: function (context, settings) {

      $(once('weaver_news', 'body', context)).each(function () {
        const weaver_news = Drupal.behaviors.weaver_news;

        weaver_news.scrollNewsFilters();

      });
    }
  };
})(jQuery, Drupal, once);